export enum TipoAcceso {
  PUBLICO = 'PUBLICO',
  PRIVADO = 'PRIVADO',
  ADMINISTRADOR = 'ADMINISTRADOR',
}
